<div class="flex flex-col gap-4">
  @if (availableTaList().length > 0) {
    <div class="flex gap-2 items-center">
      <input type="text"
             pInputText
             [(ngModel)]="searchStr"
             class="w-1/2"
             pSize="small"
             placeholder="Type to filter by TA number, destination, project code, status or staff..."
      />
      <div class="bg-white rounded-lg">
        <p-button outlined severity="secondary"
                  size="small"
                  (onClick)="clearSearchStr()">Clear</p-button>
      </div>
      <div class="flex-1"></div>
      @if (!!store && store.historyTaListCache() && store.historyTaListCache()?.totalCount! > 0){
      <a href="/clcta/reports/myHistory" download>
        <p-button outlined severity="secondary" size="small" icon="fa-regular fa-file-export" label="Export"></p-button>
      </a>
      }
      <div class="text-xs text-slate-500">
        Showing {{filteredTaList().length}} of {{store.historyTaListCache()?.totalCount}} results
      </div>
      <div class="px-3">
        <p-button label="Reload List"
                  size="small"
                  severity="primary"
                  icon="fa-solid fa-arrow-rotate-right"
                  (onClick)="reloadTaList()"></p-button>
      </div>
    </div>

    <div #scrollContainer scrollHeight [bottomPadding]="100" class="rounded-lg border-[1px] border-surface-300 overflow-y-auto">
      <p-table [value]="filteredTaList()"
               stripedRows
               [tableStyle]="{'min-width': '40rem'}"
               class="ta-list rounded-lg">
        <ng-template #header>
          <tr class="text-datatable-header-cell-color text-xs font-semibold font-['Roboto_Condensed'] text-nowrap">
            <th class="rounded-tl-lg ta-col-prepaid"></th>
            <th class="ta-col-attachment"></th>
            <th>TA Number</th>
            <th>Status</th>
            <th>Primary Traveller</th>
            <th>Destination</th>
            <th>Start</th>
            <th>End</th>
            <th>Funding Mgr</th>
            <th>Proj. Code</th>
            <th class="ta-col-actions">Actions</th>
            <th class="rounded-tr-lg ta-col-comments"></th>
          </tr>
        </ng-template>
        <ng-template #body let-taSubmission let-rowIndex="rowIndex">
          <tr class="text-xs font-normal font-['Roboto_Condensed'] hover:cursor-pointer text-nowrap" (click)="setSelectedTa(taSubmission)" (dblclick)="viewTaSubmission(taSubmission)">
            <td class="ta-col-prepaid" [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id), 'rounded-bl-lg' : (rowIndex === availableTaList().length - 1)}">
              <prepaid-indicator [taDetails]="taSubmission"></prepaid-indicator>
            </td>
            <td class="ta-col-attachment" [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">
              <attachment-indicator [taDetails]="taSubmission"></attachment-indicator>
            </td>
            <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">
              <button class="text-primary-500 hover:underline font-semibold cursor-pointer" (click)="viewTaSubmission(taSubmission); $event.stopPropagation()">
                {{taSubmission.taNumber}}
              </button>
            </td>
            <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">
              <p-chip>
                <div class="whitespace-nowrap">{{toTAStatusText(taSubmission.status)}}</div>
              </p-chip>
            </td>
            <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">
              <div class="flex gap-1 items-center">
                @if (taSubmission.travellerCount > 1) {
                  <i class="fa-solid fa-users"></i>
                } @else {
                  <i class="fa-solid fa-user"></i>
                }
                <span>{{taSubmission.primaryTraveller?.details?.name}}</span>
              </div>
            </td>
            <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">
              @if (!!taSubmission.mainDestinationLocationName && locationService.outOfRegion(taSubmission.mainDestinationLocationName)) {
                <span class="text-purple-700 font-normal">{{ taSubmission.mainDestinationLocationName + ' ❖' }}</span>
              } @else {
                {{taSubmission.mainDestinationLocationName}}
              }
            </td>
            <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">{{taSubmission.startDate | date:'dd/MM/yy'}}</td>
            <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">{{taSubmission.endDate | date:'dd/MM/yy'}}</td>
            <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">{{taSubmission.projectApprover?.name ?? ''}}</td>
            <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">{{taSubmission.projectCode}}</td>
            <td class="ta-col-actions" [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">
              <div class="flex flex-col justify-start">
                <p-button [style]="{height:'1.8em'}" [text]="true" severity="primary" size="small" (onClick)="viewTaSubmission(taSubmission); $event.stopPropagation()">Open</p-button>
                @if (canCreateTemplateFrom(taSubmission)) {
                  <p-button [style]="{height:'1.8em'}" [text]="true" severity="primary" size="small" data-testid="ta-row-create-template" (onClick)="createTemplate.emit(taSubmission); $event.stopPropagation()">Save as Template</p-button>
                }
              </div>
            </td>
            <td class="ta-col-comments" [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id), 'rounded-br-lg' : (rowIndex === availableTaList().length - 1)}">
              <ta-comment-count [count]="taSubmission.commentCount"></ta-comment-count>
            </td>
          </tr>
        </ng-template>
        <ng-template #footer>
          @if (filteredTaList().length === 0) {
            <tr class="text-xs font-normal font-['Roboto_Condensed']">
              <td class="rounded-bl-lg rounded-br-lg " colspan="12"> <i>No results.</i></td>
            </tr>
          }
        </ng-template>
      </p-table>

      @if (canLoadMore()) {
        <div #loadMoreSentinel class="flex items-center justify-center gap-3 py-3">
          <p-button label="Load More"
                    severity="secondary"
                    size="small"
                    icon="fa fa-arrow-down"
                    [disabled]="isLoading()"
                    (onClick)="loadMore()">
          </p-button>
        </div>
      }
    </div>

    <div class="self-stretch justify-start"><span class="text-purple-700 text-sm font-normal font-['Inter']">NAME ❖</span><span class="text-text-color text-sm font-normal font-['Inter']"> - indicates an Out of Region TA Application</span></div>
  } @else if (isLoading()) {
    <div class="self-stretch justify-start text-slate-500 text-sm font-normal font-['Inter'] leading-6">Loading...</div>
  } @else {
    <div class="self-stretch justify-start text-slate-500 text-sm font-normal font-['Inter'] leading-6">Your history is empty.</div>
  }
</div>
